import React, { useState, useEffect } from "react";
import axios from "axios";
import "./UniversitySubject.css";
import { useNavigate } from "react-router-dom";

const AllUniversitySubjectiveExamPricing = () => {
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [data, setData] = useState([]);
  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);
  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => {
          const coursesData = response.data?.data || [];
          setCourses(coursesData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [universityId]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesterData = response.data?.data || [];
        setSemesters(semesterData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getPrice = async (e) => {
    e.preventDefault();
    await axios
      .get(
        `${API_BASE_URL}/pricing/subjective-exam?courseId=${courseId}&semesterId=${semesterId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      )
      .then((response) => {
        console.log(response?.data?.data);
        setData(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
        window.alert("Error while fetching the university exam notes price");
      });
  };

  console.log(data, "+++++++++++++++++++++++++++++++++++++++++++++");
  return (
    <div id="wrapper">
      <div className="header">
        <h5>University Subjective Exam Pricing</h5>
        <div className="exam-btn-group">
          <button
            className="viewAllNotesBtn "
            onClick={() =>
              navigate(
                "/subjective-exam-pricing/add-university-subjective-exam-pricing",
              )
            }
          >
            + Add Price
          </button>
          <button className="addNewNoteBtn">All Price</button>
        </div>
      </div>
      <div className="allform-container" id="form">
        <form
          onSubmit={getPrice}
          encType="multipart/form-data"
          className="note-detail-form"
        >
          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Select University</label>
            <select
              className="new-chapter-dropdown"
              value={universityId}
              onChange={(e) => setUniversityId(e.target.value)}
              required
            >
              <option value="">-Select University-</option>
              {universities.map((universitie, idx) => (
                <option key={idx} value={universitie._id}>
                  {universitie.universityName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Course Name</label>
            <select
              className="new-chapter-dropdown"
              value={courseId}
              onChange={(e) => setCourseId(e.target.value)}
              required
            >
              <option value="">-Select Course-</option>
              {courses.map((course, idx) => (
                <option key={idx} value={course._id}>
                  {course.courseName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Semester</label>
            <select
              className="new-chapter-dropdown"
              value={semesterId}
              onChange={(e) => setSemesterId(e.target.value)}
              required
            >
              <option value="">-Select Semester-</option>
              {semesters.map((semester, idx) => (
                <option key={idx} value={semester._id}>
                  {semester.semesterName}
                </option>
              ))}
            </select>
          </div>

          <div className="form2-btns">
            <button className="btn-save" type="submit">
              Search
            </button>
          </div>
        </form>
      </div>
      <div className="classes-table-container">
        <h5>All Pricing</h5>
        <table className="table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Course Name</th>
              <th>Semester Name</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item?._id}>
                <td>{index + 1} </td>
                <td>{item?.courseId?.courseName} </td>
                <td>{item?.semesterId?.semesterName} </td>
                <td> ₹{item?.price} </td>
                <td
                  onClick={() => {
                    navigate(
                      `/subjective-exam-pricing/edit-university-subjective-exam-pricing/${item?._id}`,
                      {
                        state: {
                          dataItem: item,
                        },
                      },
                    );
                  }}
                >
                  Edit{" "}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllUniversitySubjectiveExamPricing;
